<message-message [text]="messageChoicePrompt().promptText" [occurredAt]="occurredAt" [showAvatar]="showAvatar"></message-message>
@if (showChoiceOptionsSig()) {
    @for (choice of messageChoicePrompt().choices; track choice.id) {
        <message-choice-option [choiceOption]="choice" (choiceOptionSelected)="onChoiceOptionSelected($event)"> </message-choice-option>
    }
}
